import { useMutation } from '@tanstack/react-query'

import {
  GetSimulacaoDuplicarService,
  type TGetSimulacaoDuplicarResponse,
} from '@/features/simulador/services/get-simulacao-duplicar.service'
import {
  isSimulacaoErrorCode,
  getSimulacaoErrorMessage,
  type SimulacaoErrorCode,
} from '@/features/simulador/utils/error-messages'
import type { AxiosErrorMap } from '@/infra/http'
import { showToast } from '@/infra/sonner'
import { assertErrorResponse } from '@/utils/assert-error-response'

export const useGetSimulacaoDuplicar = () => {
  return useMutation<TGetSimulacaoDuplicarResponse, AxiosErrorMap<SimulacaoErrorCode>, string>({
    mutationFn: async (simulacaoId: string) => {
      const response = await new GetSimulacaoDuplicarService().execute(simulacaoId)
      return response.data
    },
    onError: (error) => {
      assertErrorResponse(error)
      const apiError = error.response.data.find((err) => isSimulacaoErrorCode(err.code))
      const errorMessage = apiError ? getSimulacaoErrorMessage(apiError.code) : 'Erro ao duplicar simulação'
      showToast({ message: errorMessage, variant: 'error', closeButton: true })
    },
  })
}
